module.exports = __webpack_public_path__ + "img/ico_home.01785f9c.svg";